export enum ELoginEduView {
    static = 'static',
    modal = 'modal',
}
